import { ControlType, FieldBase, FieldBaseOptions } from './field-base';
import { Option as InputOption } from '@vendasta/forms';
import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface Option {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface DropDownFieldOptions extends FieldBaseOptions {
  options: Option[] | InputOption[] | string[];
  allowMultiples?: boolean;
  allowDuplicates?: boolean;
  maxChoices?: number;
}

export class DropdownField extends FieldBase<string | string[]> {
  readonly controlType: ControlType = 'dropdown';
  options: Option[] | InputOption[];
  allowMultiples: boolean;
  allowDuplicates: boolean;
  maxChoices: number;

  constructor(options: DropDownFieldOptions) {
    super(options);
    this.options = [];
    if (!!options.options && options.options.length > 0) {
      if (typeof options.options[0] === 'string') {
        if (options.allowMultiples) {
          this.options = options.options.map((o) => <InputOption>{ value: o, name: o });
        } else {
          this.options = options.options.map((o) => <Option>{ value: o, label: o });
        }
      } else {
        if (options.allowMultiples) {
          this.options = options.options.map((o) => <InputOption>{ value: o.value, name: o.label });
        } else {
          this.options = options.options as Option[];
        }
      }
    }

    this.allowMultiples = !!options.allowMultiples;
    this.allowDuplicates = !!options.allowDuplicates;
    this.maxChoices = options.maxChoices ? options.maxChoices : 1;

    this.validator = this.validatorBuilder();
  }

  protected validatorBuilder(): ValidatorFn {
    const maxChoices = this.maxChoices;
    return (control: AbstractControl): { [key: string]: any } => {
      if (Array.isArray(control.value) && maxChoices && control.value.length > maxChoices) {
        return { overMaxChoices: true };
      }
    };
  }
}
